var React = require('react');
var Icon = require('../../common/Icon/Icon.js');

require('./Dialog.scss');

class Dialog extends React.Component {
    constructor(props) {

        super(props);
        this.dialog = React.createRef();
        this.dialogButton = React.createRef(); 

    }

    handleDialogClose(e) {

        if (
            e.target !== this.dialog.current &&
            e.target !== this.dialogButton.current
        ) {

            return;

        }

        this.dialog.current.close();
    
    }

    render() {
        const closeButtonOutside = this.props.additionalClass && this.props.additionalClass.includes('c-dialog--close-button-outside');
        const closeIcon = closeButtonOutside ? 'closeAlt' : 'close';
        return (
            <dialog className={`c-dialog${this.props.additionalClass ? ` ${this.props.additionalClass}` : ""}`} data-dialog={this.props.name} ref={this.dialog} onClick={this.handleDialogClose.bind(this)}>
                <div className="c-dialog__inner">
                    <div className="c-dialog__header">
                        <button type="button" className="c-dialog__header__close" ref={this.dialogButton}>
                            <Icon className="c-dialog__header__close__icon" name={closeIcon} width={30} height={30} />
                            {closeButtonOutside ? (<span>Close<span className="u-visually-hidden"> dialog</span></span>) : (<span className="u-visually-hidden">Close dialog</span>)}
                        </button>
                    </div>
                    {this.props.children}
                </div>
            </dialog>
        );
    }
};

module.exports = Dialog;


// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.js